import { PackagingMaterialType } from "../../../../../config/enums/PackagingMaterialType";
import { PackagingType } from "../../../../../config/enums/PackagingType.enum";

export interface PackageValidationInput {
  packagingType: PackagingType;
  unitSizes: number;
  palletLength?: number;
  palletWidth?: number;
  defaultMaterialType: number;
  levelTitle: string;
  fieldName: string;
}

export interface PackageValidationError {
  field: string;
  message: string;
}

export const validatePackageData = (
  input: PackageValidationInput
): PackageValidationError | null => {
  const { packagingType, unitSizes, palletLength, palletWidth, defaultMaterialType, levelTitle, fieldName } =
    input;

  if (packagingType !== PackagingType.TRANSPORT_UNIT_PACKAGING && unitSizes === 0) {
    return { field: fieldName, message: `${levelTitle} is required` };
  }

  if (packagingType === PackagingType.TRANSPORT_UNIT_PACKAGING) {
    if (unitSizes === 0 || (palletLength ?? 0) === 0 || (palletWidth ?? 0) === 0) {
      return {
        field: fieldName,
        message: `${levelTitle} No of Cases , Width and Length is required`
      };
    }
  }

  if (defaultMaterialType === PackagingMaterialType.DEFAULT) {
    return { field: "packageMaterial", message: "Packaging material is required" };
  }

  return null;
};

export const shouldSkipPackagingNameDuplicateCheck = (
  existingName: string | undefined,
  newName: string | undefined
): boolean => existingName === newName;

export const resolveWasteManagementMethod = (
  wasteManagementTypes: Array<{ value: number | string }> | undefined,
  selectedValue: number | string | null | undefined
): number | null => {
  if (selectedValue == null || selectedValue === "") {
    return null;
  }

  const match = wasteManagementTypes?.find(option => String(option.value) === String(selectedValue));
  return match ? Number(match.value) : null;
};
